// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-image {
  z-index: 0;
}
.v-image__image,
.v-image__placeholder {
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.v-image__image {
  background-repeat: no-repeat;
}
.v-image__image--preload {
  filter: blur(2px);
}
.v-image__image--contain {
  background-size: contain;
}
.v-image__image--cover {
  background-size: cover;
}
`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/src/stylus/components/_images.styl"],"names":[],"mappings":"AAEA;EACE,UAAS;AADX;AAGE;;EAEE,WAAS;EACT,kBAAU;EACV,MAAK;EACL,OAAM;EACN,WAAO;EACP,YAAQ;AADZ;AAGE;EACE,4BAAmB;AADvB;AAGI;EACE,iBAAQ;AADd;AAGI;EACE,wBAAiB;AADvB;AAGI;EACE,sBAAiB;AADvB","sourcesContent":["@import '../bootstrap'\n\n.v-image\n  z-index: 0\n\n  &__image,\n  &__placeholder\n    z-index: -1\n    position: absolute\n    top: 0\n    left: 0\n    width: 100%\n    height: 100%\n\n  &__image\n    background-repeat: no-repeat\n\n    &--preload\n      filter: blur(2px)\n\n    &--contain\n      background-size: contain\n\n    &--cover\n      background-size: cover\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
